// 项目资源库
import * as asset from '@ps/api/asset'

// 项目资源类型 id 类表
export const componentCategories = {
  image: 1, // 图片
  audio: 2, // 音效
  xlz: 3, // 序列帧
  particle: 7, // 粒子
  dragonBone: 8, // 龙骨
  video: 5, // 视频
  bgm: 6 // 背景音乐
}

export function createComponent(params: {
    files: File[];
    pid: number;
    name: string;
    category: 'xlz'
} | {
  file: File;
  pid: number;
  name: string; // 保存原始名字到远端，保证从资源库新增资源时能够使用原有的名字
  category: 'image' | 'audio' | 'bgm' | 'video' | 'dragonBone';
}) {
  if (params.category === 'xlz') {
    const { files, pid, name } = params
    const formData = new FormData()
    formData.append('pid', String(pid))
    formData.append('data', JSON.stringify(files))
    formData.append('cat_id', String(componentCategories.xlz))
    formData.append('name', name.toLowerCase())
    return asset.createComponent(formData)
  }

  const { file, pid, name, category } = params
  const formData = new FormData()
  formData.append('pid', String(pid))

  const fileName = name || file.name
  // 引擎只认小写后缀
  formData.append('file', file, fileName.toLowerCase())
  formData.append('name', fileName.toLowerCase())

  const utils = {
    image: () => {
      formData.append('cat_id', String(componentCategories.image))
      return asset.createComponent(formData)
    },
    audio: () => {
      formData.append('cat_id', String(componentCategories.audio))
      return asset.createComponent(formData)
    },
    bgm: () => {
      formData.append('cat_id', String(componentCategories.bgm))
      return asset.createComponent(formData)
    },
    video: () => {
      formData.append('cat_id', String(componentCategories.video))
      return asset.createComponent(formData)
    },
    dragonBone: () => {
      formData.append('cat_id', String(componentCategories.dragonBone))
      return asset.createComponent(formData)
    }
  }
  return utils[category]()
}
